/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { shape, string, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { setPaymentMethodStatus as setPaymentMethodStatusAction } from 'actions/paymentMethod';

import { STATUS } from 'reducers/paymentMethod';

import Button from 'components/Button/Button';

import styles from './view-payment-method.scss';

/**
 * This is the ViewPaymentMethod component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ViewPaymentMethod extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: shape({
      payment_method_label: string.isRequired,
    }).isRequired,
    setPaymentMethodStatus: func.isRequired,
  };

  onChangeMethod = () => {
    const { setPaymentMethodStatus } = this.props;

    return setPaymentMethodStatus(STATUS.SELECT_METHOD);
  };

  /**
   * Render ViewPaymentMethod.
   *
   * @return {Object}
   */
  render() {
    const { user: { payment_method_label } } = this.props;

    return (
      <article className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.content}>
            <h1 className={styles.title}>{payment_method_label}</h1>

            <Button onClick={this.onChangeMethod}>
              {p.t('payments.change_payment_method')}
            </Button>
          </div>
        </div>
      </article>
    );
  }
}

export default connect(({ user }) => ({ user }), {
  setPaymentMethodStatus: setPaymentMethodStatusAction,
})(ViewPaymentMethod);
